module.exports = "<!-- main app container -->\n  <div class=\"col-sm-8 col-sm-offset-2\">\n    <alert></alert>\n    <ng4-loading-spinner> </ng4-loading-spinner>\n  </div>\n  <router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main